module.exports = __webpack_public_path__ + "static/media/check_thin.75b78336.svg";